import { Decisao } from 'app/entity/decisao.model';
import { Homologacao } from 'app/entity/homologacao';
import { PontuacaoRascunhoDeJulgamento } from 'app/entity/pontuacao-rascunho-de-julgamento.model';

export class RascunhoDeJulgamento {
    public id: number;
    public id_homologacao: number;
    public id_decisao: number;
    public parecer: string;
    public data_julgamento: Date;
    public perfil: string;
    public decisao: Decisao;
    public homologacao: Homologacao;
    public pontuacao_rascunho_de_julgamento: PontuacaoRascunhoDeJulgamento[]  = [];
}



// WEBPACK FOOTER //
// ./src/app/entity/rascunho-de-julgamento.model.ts